import { menu, type IconeComponente } from "./navegacao";

/**
 * Ícone do módulo a partir da rota atual.
 *
 * É a mesma fonte do menu lateral (`navegacao.ts`), então o modal exibe
 * exatamente o ícone do item em que o usuário está — sem cada tela precisar
 * informar o seu. A escolha é pelo prefixo mais específico: `/cadastros/etapas`
 * casa com "Cadastros", `/producao/kanban` com "Produção", e assim por diante.
 */
export function iconeModuloDaRota(pathname: string): IconeComponente | null {
  const rota = String(pathname || "").toLowerCase();
  let melhorTamanho = -1;
  let melhorIcone: IconeComponente | null = null;

  const considerar = (rotaItem: string | undefined, Icone: IconeComponente) => {
    const base = String(rotaItem || "").toLowerCase();
    /* A raiz ("/") só vale para ela mesma: senão casaria com qualquer rota. */
    if (!base || (base === "/" && rota !== "/")) return;
    if (base !== "/" && rota !== base && !rota.startsWith(`${base}/`)) return;
    if (base.length > melhorTamanho) {
      melhorTamanho = base.length;
      melhorIcone = Icone;
    }
  };

  menu.forEach((item) => {
    considerar(item.rota, item.Icone);
    (item.subitens || []).forEach((subitem) => considerar(subitem.rota, item.Icone));
  });

  return melhorIcone;
}
